module.exports = __webpack_public_path__ + "img/icon-arrow-right-opt.821a3828.svg";